import { forwardRef, createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import SuiBox from "components/SuiBox";
import SuiPaginationItemRoot from "components/SuiPagination/SuiPaginationItemRoot";

const Context = createContext(null);

const SuiPagination = forwardRef(
  ({ item, variant, color, size, active, children, ...rest }, ref) => {
    const context = useContext(Context);
    const paginationSize = context ? context.size : null;
    const value = useMemo(() => ({ variant, color, size }), [variant, color, size]);

    return (
      <Context.Provider value={value}>
        {item ? (
          <SuiPaginationItemRoot
            {...rest}
            ref={ref}
            variant={active ? context.variant : "outlined"}
            color={active ? context.color : "secondary"}
            iconOnly
            circular
            ownerState={{ variant, active, paginationSize }}
          >
            {children}
          </SuiPaginationItemRoot>
        ) : (
          <SuiBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ listStyle: "none" }}
            padding="15px"
            bgColor='white'
          >
            {children}
          </SuiBox>
        )}
      </Context.Provider>
    );
  }
);

SuiPagination.defaultProps = {
  item: false,
  variant: "gradient",
  color: "info",
  size: "medium",
  active: false,
};

SuiPagination.propTypes = {
  item: PropTypes.bool,
  variant: PropTypes.oneOf(["gradient", "contained"]),
  color: PropTypes.oneOf([
    "white",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  active: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default SuiPagination;
